module.exports = __webpack_public_path__ + "img/icon6.495c649e.png";